import { gnhUsersSubmittedFormListRoute,gnhDrivingExemptionBlankFormRoute, drivingExemptionRoute, lvCommuteExemptionBlankFormRoute, drivingExemptionOverviewPathRoute, drivingExemptionDetailsPathRoute, drivingExemptionOnBehalfRoute } from "./DrivingExemptionRoutes";

export const allDrivingExemptionRoutes = (): any[] => {
    const routes = [
        drivingExemptionRoute,
        gnhDrivingExemptionBlankFormRoute,
        gnhUsersSubmittedFormListRoute,
        lvCommuteExemptionBlankFormRoute,
        drivingExemptionOverviewPathRoute,
        drivingExemptionDetailsPathRoute,
        drivingExemptionOnBehalfRoute
    ];
    return routes;
};
